import React, {useState, useEffect} from 'react';
import {toJS} from 'mobx';

import {Form, Row, Col, Input, Button, Select} from 'antd';
import store from "./store";
import {observer} from 'mobx-react';
import lodash from "lodash";

import styles from '../layout.module.less'

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function (props) {
  const { t } = useTranslation();
  const [invoice, setInvoice] = useState(toJS(store.invoice))
  const [loading, setLoading] = useState(false)


  const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 14},
  };

  const oneLine = {
    labelCol: {span: 4},
    wrapperCol: {span: 19},
  };


  const onFinish = values => {
    setLoading(true)

    store.update(values).then(() => {
      props.setVisible()
    }).finally(() => {
      setLoading(false)
    })


  }

  return (
    <React.Fragment>

      <div className={styles.formModalContent}>
        <div className={styles.formBox}>


          <Form
            {...layout}
            name="basic"
            className={styles.form}
            initialValues={invoice}
            validateTrigger='onBlur'
            onFinish={onFinish}
          >
            <Row gutter={24}>
              <Col span={12} style={{paddingLeft: '0.0938rem'}}>
                <Form.Item
                  label="发票抬头"
                  name="title"
                  rules={[{required: true, message: '请输入!'}]}
                >
                  <Input/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="纳税登记号"
                  name="tax_sn"
                  rules={[{required: true, message: '请输入!'}]}
                >
                  <Input/>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={12} style={{paddingLeft: '0.0938rem'}}>
                <Form.Item
                  label="开户银行"
                  name="bank_name"
                  rules={[{required: true, message: '请输入!'}]}
                >
                  <Input/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="开票联系电话"
                  name="phone"
                  rules={[
                    {required: true, message: '请输入!'},
                    {pattern: /^[1]([3-9])[0-9]{9}$/, message: '请输入正确的手机号码'}
                  ]}
                >
                  <Input/>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={12} style={{paddingLeft: '0.0938rem'}}>

                <Form.Item
                  label="银行账号"
                  name="bank_number"
                  rules={[{required: true, message: '请输入!'}]}
                >
                  <Input/>
                </Form.Item>
              </Col>
              <Col span={12}>


              </Col>
            </Row>


            <Form.Item
              {...oneLine}
              label="开票通讯地址"
              name="address"
              rules={[{required: true, message: '请输入!'}]}
            >
              <Input/>
            </Form.Item>


            {/*隐藏元素*/}
            <Form.Item
              name="id"
              hidden={true}
            >
              <Input/>
            </Form.Item>
            <Form.Item
              name="is_default"
              hidden={true}
            >
              <Input/>
            </Form.Item>
            <Form.Item
              name="is_del"
              hidden={true}
            >
              <Input/>
            </Form.Item>
            <Form.Item
              name="customer_id"
              hidden={true}
            >
              <Input/>
            </Form.Item>


            <div style={{padding: '0.0521rem 0.2708rem 0.1042rem'}}>标记“<a>*</a>”的为必填项</div>

            <div style={{textAlign: 'center'}}>
              <Button type="primary" htmlType="submit" size='large' loading={loading}>保存</Button>
            </div>
          </Form>

        </div>

      </div>

    </React.Fragment>
  )
})
